import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SalaryList } from '@/components/company/salary/table';

const salarySearchSchema = z.object({
  page: z.number().optional().catch(1),
  limit: z.number().optional().catch(20),
  search: z.string().optional(),
  startDate: z.string().optional(), // YYYY-MM-DD
  endDate: z.string().optional(), // YYYY-MM-DD
});

export const Route = createFileRoute('/(app)/company/salary/')({
  component: SalaryRoute,
  validateSearch: salarySearchSchema,
});

function SalaryRoute() {
  return <SalaryList />;
}
